import React from 'react';

import { GTMTracking } from '@common/ui/general';
import { useMediaQuery } from '@common/hooks';
import classNames from 'classnames';

import bagIcon from '@alumni_v2/images/svg/bagIcon.svg';
import collegeIcon from '@alumni_v2/images/svg/building.svg';
import frame from '@alumni_v2/images/webp/frame.webp';
import graduationHatIcon from '@alumni_v2/images/svg/graduation-hat.svg';
import linkedinIcon from '@alumni_v2/images/svg/linkedin.svg';
import locationIcon from '@alumni_v2/images/svg/location.svg';
import scalerLogo from '@alumni_v2/images/svg/Logomark_Scaler.svg';
import ratingIcon from '@alumni_v2/images/svg/star.svg';

import styles from './ProfileBox.module.scss';

const ProfileBox = ({
  name,
  profileImg,
  designation,
  postScalerText,
  location,
  availableForQnA,
  programDetails,
  linkedinId,
  collegeName,
  deegree,
  workExperience,
  rating,
}) => {
  const { mobile } = useMediaQuery();

  return (
    <div className={styles.profileContainer}>

      <div className={styles.userInfo}>
        {availableForQnA ? (
          <div className={styles.backProfileImg}>
            <img
              className={styles.profileImg}
              src={profileImg}
              alt="profileImg"
            />
            <img
              className={styles.profileImgAlt}
              src={frame}
              alt="profileImg"
            />
          </div>
        ) : (
          <div className={styles.alumniImg}>
            <img src={profileImg} alt="profileImg" />
          </div>
        )}

        <div className={styles.profileDetails}>

          <div className={styles.name}>{name}</div>
          <div className={styles.programDetails}>
            <img src={scalerLogo} alt="ScalerLogo" />
            {programDetails}
          </div>
          {mobile ? <div /> : (
            <div className={styles.designationInfo}>
              {designation}
              {' '}
              at
              {' '}
              {postScalerText}
            </div>
          )}
          <GTMTracking
            component="button"
            gtmEventType="cta"
            gtmEventAction="click"
            gtmEventResult="connect_on_linkedin"
            gtmEventCategory="alumni_directory"
            className={styles.linkedinCta}
            gtmEventData={{
              click_type: 'connect_on_linkedin',
              click_text: name,
            }}
          >
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={linkedinId}
              className={styles.linkedinBtn}
            >
              <img src={linkedinIcon} alt="linkedin-icon" />
              <div>Connect</div>
            </a>
          </GTMTracking>
        </div>
      </div>

      <div className={styles.lowerUserInfo}>
        {mobile ? (
          <>
            {rating > 0 && (
              <div className={styles.horizontalInfo}>
                User rating:
                {Array.from({ length: 5 }, (_, i) => (
                  <img
                    src={ratingIcon}
                    className={classNames(
                      styles.rating,
                      { [styles.highlight]: (i + 1 <= Math.ceil(rating)) },
                    )}
                    key={i}
                    alt="ratingIcon"
                  />
                ))}
              </div>
            )}
            <div className={styles.designationInfoMobile}>
              {designation}
              {' '}
              at
              {' '}
              {postScalerText}
            </div>
            <div className={styles.educationDetails}>
              <div className={styles.horizontalInfo}>
                <img src={locationIcon} alt="location-icon" />
                {location}
              </div>
              <div className={styles.horizontalInfo}>
                <img src={graduationHatIcon} alt="graduationHat-icon" />
                {deegree}
              </div>
            </div>

            <div className={styles.horizontalInfo}>
              <img src={collegeIcon} alt="college-icon" />
              {collegeName}
            </div>
          </>
        ) : (
          <>
            {rating > 0 && (
              <div className={styles.horizontalInfo}>
                User rating:
                {Array.from({ length: 5 }, (_, i) => (
                  <img
                    src={ratingIcon}
                    className={classNames(
                      styles.rating,
                      { [styles.highlight]: (i + 1 <= Math.ceil(rating)) },
                    )}
                    key={i}
                    alt="ratingIcon"
                  />
                ))}
              </div>
            )}
            <div className={styles.horizontalInfo}>
              <img src={locationIcon} alt="location-icon" />
              {location}
            </div>

            <div className={styles.educationDetails}>
              <div className={styles.horizontalInfo}>
                <img src={collegeIcon} alt="college-icon" />
                {collegeName}
              </div>
              <div className={styles.horizontalInfo}>
                <img src={graduationHatIcon} alt="graduationHat-icon" />
                {deegree}
              </div>
            </div>
          </>
        )}

        {workExperience !== null && (
          <div className={styles.horizontalInfo}>
            <img src={bagIcon} alt="bag-icon" />
            <div>
              {workExperience}
              {' '}
              work experience pre Scaler
            </div>
          </div>
        )}
      </div>

    </div>
  );
};

export default ProfileBox;
